import script from "./AppPageFrame.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppPageFrame.vue?vue&type=script&lang=ts&setup=true"

import "./AppPageFrame.vue?vue&type=style&index=0&id=77316024&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77316024"]])

export default __exports__